import { matchPath } from 'react-router';
import {
  EnvImage,
  Home,
  Login,
  Staff,
  StaffList,
  StaffDetail,
  Activity,
  ActivityList,
  ActivityDetail,
  Res,
  ResList,
  ResDetail,
  KinderDetail,
  XnsyList,
  XnsyDetail,
  XnsyReport
} from 'pages'

type Mete = {
  title: string,
  hideMenu?: boolean
}

// 对象参数类型
export type RouterType = {
  name: string,
  path: string,
  component: React.LazyExoticComponent<any>,
  meta: Mete,
  root?: string[],
  notExect?: boolean,
}


// 总路由
const Routers: RouterType[] = ([
  {
    name: "home",
    path: "/home",
    component: Home,
    meta: {
      title: "幼儿园环境",
    }
  },{
    name: "kinderDetail",
    path: "/kinder/detail/:kinderId",
    component: KinderDetail,
    meta: {
      title: "详情",
    },
    root: ["home", "kinderDetail"]
  },{
    name: "login",
    path: "/login",
    component: Login,
    meta: {
      title: "登录",
      hideMenu: true
    }
  },{
    name: "envImage",
    path: "/envImage",
    component: EnvImage,
    meta: {
      title: "全景图片",
      hideMenu: true
    }
  },{
    name: "staff",
    path: "/staff",
    component: Staff,
    meta: {
      title: "幼儿园成员"
    }
  },{
    name: "staffList",
    path: "/staff/list",
    component: StaffList,
    meta: {
      title: "岗位列表"
    },
    root: ["staff", "staffList"]
  },{
    name: "staffDetail",
    path: "/staff/detail/:staffId",
    component: StaffDetail,
    meta: {
      title: "详情"
    },
    root: ["staff", "staffList", "staffDetail"]
  },{
    name: "activity",
    path: "/activity",
    component: Activity,
    meta: {
      title: "幼儿园活动"
    }
  },{
    name: "activityList",
    path: "/activity/:catalogType/list",
    component: ActivityList,
    meta: {
      title: "活动列表"
    },
    root: ["activity", "activityList"]
  },{
    name: "activityDetail",
    path: "/activity/:catalogType/detail/:infoId",
    component: ActivityDetail,
    meta: {
      title: "详情"
    },
    root: ["activity", "activityList", "activityDetail"]
  },{
    name: "res",
    path: "/res",
    component: Res,
    meta: {
      title: "虚拟资源"
    }
  },{
    name: "resList",
    path: "/res/list/:type",
    component: ResList,
    meta: {
      title: "资源列表"
    },
    root: ["res", "resList"]
  },{
    name: "resDetail",
    path: "/res/detail/:resId",
    component: ResDetail,
    meta: {
      title: "详情"
    },
    root: ["res", "resDetail"]
  },{
    name: "xnsyList",
    path: '/xnsy',
    component: XnsyList,
    meta: {
      title: "虚拟实验"
    },
    root: ["xnsyList"]
  },{
    name: "xnsyDetail",
    path: '/xnsy/detail/:kinderId',
    component: XnsyDetail,
    meta: {
      title: "详情"
    },
    root: ["xnsyList", "xnsyDetail"]
  },{
    name: "xnsyReport",
    path: '/xnsy/report',
    component: XnsyReport,
    meta: {
      title: "实验数据"
    },
    root: ["xnsyReport"]
  }
])

/**
 * path 对应页面配置
 * @param path 
 * @returns 
 */
const getRouterType = (path:string): RouterType=>{
  let ret: RouterType = Routers[0];
  Routers.some(rt=>{
    const match = matchPath(path, {
      path: rt.path,
      exact: true,
    })
    if(match) {
      ret = rt;
      return true;
    }
    return false
  })
  return ret;
}

/**
 * 
 * @param root 路径
 * @returns 
 */
const getRouterTypeByRoot = (root?:string[]): RouterType[]=>{
  let ret: RouterType[] = []
  if(!root) return ret
  for(let name of root){
    const find = Routers.find(rt=>{
      return rt.name === name
    });
    if(find)
      ret.push(find)
  }
  return ret
}

/**
 * 是否隐藏菜单
 * @param path 页面url
 * @returns 
 */
const hideMenu = (path:string): boolean=>{
  const rt: RouterType  = getRouterType(path)
  if(rt != null && rt.meta != null){
    if(rt.meta.hideMenu){
      return true
    }
  }
  return false;
}

export {
  Routers,
  getRouterType,
  getRouterTypeByRoot,
  hideMenu
}